import { render, staticRenderFns } from "./StaticMaterials.vue?vue&type=template&id=2016bcca&scoped=true&"
import script from "./StaticMaterials.vue?vue&type=script&lang=js&"
export * from "./StaticMaterials.vue?vue&type=script&lang=js&"
import style0 from "./StaticMaterials.vue?vue&type=style&index=0&id=2016bcca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2016bcca",
  null
  
)

export default component.exports